const NAV = [
  ["#goal", "想做什麼"],
  ["#results", "直接效應"],
  ["#bonus", "外溢效益"],
  ["#pillars", "4 大配合"],
  ["#tasks", "細部清單"],
  ["#schedule", "排程"],
  ["#conclusion", "結論"],
];

export const Header = () => (
  <header data-testid="site-header" className="sticky top-0 z-40 border-b border-[var(--line)] bg-white/95 backdrop-blur-xl">
    <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-3">
      <div className="flex items-center gap-3">
        <img src="/assets/logo.webp" alt="Lakeze 人客多" className="h-8 w-auto md:h-9" data-testid="header-logo" />
        <span className="hidden border-l border-[var(--line)] pl-3 text-sm font-black text-[var(--ink)] sm:inline">人客多 零元滿房計畫</span>
      </div>
      <nav className="hidden gap-6 text-sm font-bold text-[var(--text)] md:flex">
        {NAV.map(([href, label]) => (
          <a key={href} href={href} data-testid={`nav-${href.slice(1)}`} className="transition-colors hover:text-[var(--orange)]">{label}</a>
        ))}
      </nav>
    </div>
  </header>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[var(--line)] bg-white">
    <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-4 px-5 py-10 md:flex-row md:items-center">
      <img src="/assets/logo.webp" alt="Lakeze 人客多" className="h-10 w-auto" data-testid="footer-logo" />
      <p className="text-sm text-[var(--muted)]">人客多「零元滿房計畫」× 名人堂・多間飯店與包棟民宿實戰累積</p>
    </div>
  </footer>
);
